
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {Roll} from '@/types/Roll';
import {get, ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {DamageRoll} from '@/types/DamageRoll';
import PadoNPCComponent from './PadoNPCComponent.vue';
import PadoMapComponent from '@/components/ParceDomine/PadoMapComponent.vue';
import PadoMJTurnOrderComponent from '@/components/ParceDomine/PadoMJTurnOrderComponent.vue';
import {MJMixin} from '@/mixins/MJMixin';

@Component({
    components: {PadoMJTurnOrderComponent, PadoMapComponent, PadoNPCComponent},
})

export default class PadoMJComponent extends mixins(MJMixin) {
    critic = false;

    created(): void {
        this.npcs = Array(Object.values(this.game.characters).filter(char => {
            return char.isNPC;
        }).length);
        for (let i = 0; i < this.npcs.length; i++) {
            this.npcs[i] = false;
        }
    }

    async rollDamage(type: string): Promise<void> {
        if (this.game) {
            const roll: DamageRoll = new DamageRoll(type, 'MJ');
            roll.roll(null, this.secret);
            let mjRolls: Roll[] | null = null;
            await get(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}/rolls`)).then(snap => {
                mjRolls = snap.val();
            });
            if (mjRolls === null) mjRolls = [];
            mjRolls = [roll, ...mjRolls];
            mjRolls = mjRolls.slice(0, 25);
            await set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}/rolls`), mjRolls);

            let globalRolls: Roll[] | null = null;
            await get(ref(db, `/jdrs/${this.game.id}/rolls`)).then(snap => {
                globalRolls = snap.val();
            });
            if (globalRolls === null) globalRolls = [];
            globalRolls = [roll, ...globalRolls];
            globalRolls = globalRolls.slice(0, 100);
            await set(ref(db, `/jdrs/${this.game.id}/rolls`), globalRolls);
        }
    }

}
